// src/App.js
import React, { useState } from 'react';
import { ThemeProvider } from "styled-components";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { light, dark } from "./styles/Theme";
import { GlobalStyles } from "./styles/Global";
import MainPage from './pages/MainPage';
import LandingPage from './pages/LandingPage';
import { AuthContextProvider, useAuth } from './hooks/useAuth';
import { PaymentsContextProvider } from './hooks/usePayments';
import ErrorBoundary from './components/ErrorBoundary';
import config from './config';


// Inner component that can access auth context
function AppContent({ selectedTheme, handleThemeChange }) {
  const { user } = useAuth();
  
  // Show landing page for unauthenticated users on root path
  // MainPage handles its own routing including /signin, /signup, etc.
  return user ? (
    <MainPage handleThemeChange={handleThemeChange} />
  ) : (
    <MainPage handleThemeChange={handleThemeChange} landingComponent={<LandingPage handleThemeChange={handleThemeChange} />} />
  );
}

function App() {
  // Initialize theme from localStorage, default to dark (light background)
  const [selectedTheme, setSelectedTheme] = useState(() => {
    const saved = localStorage.getItem('propninja-theme');
    return saved === 'light' ? light : dark;
  });

  const handleThemeChange = () => {
    const newTheme = selectedTheme === light ? dark : light;
    setSelectedTheme(newTheme);
    localStorage.setItem('propninja-theme', newTheme === light ? 'light' : 'dark');
  };

  return (
    <ErrorBoundary>
      <GoogleReCaptchaProvider reCaptchaKey={config.REACT_APP_RECAPTCHA_SITE_KEY}>
        <AuthContextProvider>
          <PaymentsContextProvider>
            <ThemeProvider theme={selectedTheme}>
              <div className="App">
                <GlobalStyles/>
                <AppContent selectedTheme={selectedTheme} handleThemeChange={handleThemeChange} />
              </div>
            </ThemeProvider>
          </PaymentsContextProvider>
        </AuthContextProvider>
      </GoogleReCaptchaProvider>
    </ErrorBoundary>
  );
}

export default App;